import styled from "styled-components";
import {
  TABLET,
  MOBILE,
  LARGE,
  EXTRA_LARGE,
  H3,
  Title,
  SubTitle,
} from "@minerva-analytics/pantheon";
import {
  BODY_TEXT_COLOR,
  TITLE_FONT,
  PRIMARY_FONT_TEXT,
  BACKGROUND_COLOR,
  SECONDARY_COLOR,
  PRIMARY_COLOR,
} from "../../theme";
import { ABOUT_MOBILE } from "../../image-links";

const PrimaryAboutContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 1rem 0;
  @media (max-width: ${LARGE}) {
    flex-direction: column-reverse;
  }
  @media (max-width: ${TABLET}) {
    padding-bottom: 2rem;
  }
`;

const AboutTitle = styled(Title)`
  && {
    margin: 1rem 0;
    color: ${SECONDARY_COLOR};
    text-align: left;
    font-family: ${TITLE_FONT};
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 1.05px;
    text-transform: uppercase;

    @media (max-width: ${MOBILE}) {
      font-size: 1.75rem;
    }
  }
`;

const AboutSubTitle = styled(SubTitle)`
  && {
    margin: 1rem 0;
    color: ${SECONDARY_COLOR};
    text-align: left;
    font-family: ${TITLE_FONT};
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 1.05px;
    text-transform: uppercase;

    @media (max-width: ${MOBILE}) {
      font-size: 1.75rem;
    }
  }
`;

const AboutImage = styled.img`
  width: auto;
  height: auto;
  max-width: 24rem;
  margin: 0 auto;
  @media (max-width: ${EXTRA_LARGE}) {
    width: 25rem;
  }
  @media (max-width: ${LARGE}) {
    width: 17rem;
    margin-top: 1rem;
    align-items: center;
  }
  @media (max-width: ${TABLET}) {
    margin-top: 0.5rem;
    margin-left: auto;
    margin-right: auto;
    display: block;
    content: url(${ABOUT_MOBILE});
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  width: 50%;
  @media (max-width: ${LARGE}) {
    margin: 0 auto;
  }

  @media (max-width: ${TABLET}) {
    width: 100%;
  }
`;

const AboutTexts = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  @media (max-width: ${LARGE}) {
    width: 100%;
  }
`;

const PrimaryBodyText = styled.p`
  color: ${BODY_TEXT_COLOR};
  font-family: ${PRIMARY_FONT_TEXT};
  font-size: 16px;
  letter-spacing: 0.68px;
  line-height: 33px;
  width: 100%;
  margin: 0 0 2rem;
  padding-right: 10px;
`;

const PrimaryHeader = styled(H3)`
  &&& {
    color: ${PRIMARY_COLOR};
    font-family: ${TITLE_FONT};
    font-size: 35px;
    font-weight: bold;
    letter-spacing: 0.87px;
    line-height: 50px;
    width: 100%;
    padding-bottom: 25px;
    @media (max-width: ${MOBILE}) {
      font-size: 30px;
    }
  }
`;

const Container = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  @media (max-width: ${EXTRA_LARGE}) {
    width: 87%;
  }
  @media (max-width: ${MOBILE}) {
    width: 90%;
  }
`;

const CircleContainer = styled.div`
  margin-top: 0;
  margin-bottom: 1rem;
`;

const CircleImage = styled.img`
  width: 53px;
  margin-top: 0;
  padding-bottom: 25px;
`;

const TitleContainer = styled.div`
  width: calc(100% - 2rem);
  @media (max-width: ${TABLET}) {
    width: 100%;
  }
`;

const Background = styled.div`
  background-color: ${BACKGROUND_COLOR};
  @media (min-width: ${EXTRA_LARGE}) {
    position: absolute;
    top: 0px;
    height: 100%;
    right: 0px;
    width: 100%;
  }
  z-index: -1;
`;

export {
  PrimaryAboutContainer,
  AboutTexts,
  AboutImage,
  AboutTitle,
  AboutSubTitle,
  Container,
  PrimaryBodyText,
  TitleContainer,
  ImageWrapper,
  PrimaryHeader,
  CircleContainer,
  CircleImage,
  Background,
};
